var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotSpring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.543 15.878v2.188c1.53.745 2.422 1.633 2.422 2.445 0 .936-1.186 1.975-3.172 2.778-2.332.943-5.456 1.462-8.793 1.462-3.338 0-6.46-.52-8.793-1.462-1.986-.803-3.172-1.842-3.172-2.778 0-.812.892-1.7 2.422-2.445v-2.188c-2.851 1.153-4.422 2.798-4.422 4.633 0 1.834 1.57 3.479 4.422 4.632C9.023 26.18 12.412 26.75 16 26.75c3.588 0 6.977-.571 9.543-1.608 2.852-1.153 4.422-2.798 4.422-4.632 0-1.835-1.57-3.48-4.422-4.633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.863 12.108a3.62 3.62 0 01-1.067-2.576c0-.973.379-1.887 1.067-2.576.423-.423.739-.908 1-1.414H9.449a5.606 5.606 0 00-1.653 3.99c0 1.508.587 2.925 1.653 3.99a3.648 3.648 0 010 5.152 5.619 5.619 0 00-1.161 1.707h2.334c.08-.098.15-.202.24-.293a5.651 5.651 0 000-7.98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 12.108a3.648 3.648 0 010-5.152c.42-.418.74-.903 1.004-1.414h-2.418a5.651 5.651 0 000 7.98 3.648 3.648 0 010 5.152 5.592 5.592 0 00-1.154 1.707h2.33c.078-.098.147-.2.238-.293a5.65 5.65 0 000-7.98M21.178 20.089a5.65 5.65 0 000-7.98 3.62 3.62 0 01-1.067-2.576 3.62 3.62 0 011.067-2.576c.42-.42.74-.903 1.004-1.414h-2.418a5.606 5.606 0 00-1.653 3.99c0 1.507.587 2.924 1.653 3.99a3.648 3.648 0 010 5.152 5.619 5.619 0 00-1.16 1.707h2.333c.08-.098.15-.202.241-.293"
  })))));
}

export default SvgIconHotSpring;